import NiceModal, { useModal } from '@ebay/nice-modal-react';

// Import components
import { AntModal } from 'components/views/offer_configurator/components/common';

type Props = {
	currentPacket: string;
	newPacket: string;
	setPacket: () => void;
};

export const MainPacketChangeModal = NiceModal.create(({ currentPacket, newPacket, setPacket }: Props) => {
	const { visible, remove } = useModal();

	const handleConfirm = () => {
		setPacket();
		remove();
	};

	return (
		<AntModal
			namespace="configurator"
			title="modal_packet_change_title"
			description={{
				key: 'modal_packet_change_description',
				values: {
					current: currentPacket,
					new: newPacket
				}
			}}
			cancelText="button_cancel"
			confirmText="button_packet_change"
			visible={visible}
			onConfirm={handleConfirm}
			onCancel={remove}
		/>
	);
});
